import { Component, OnInit,NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-tapnpayconfirmation',
  templateUrl: './tapnpayconfirmation.component.html',
  styleUrls: ['./tapnpayconfirmation.component.scss']
})
export class TapnpayconfirmationComponent implements OnInit {
  showCard:any;
  txnstatus:any;
  cardNo: any;
  regDateTime: any;
  maskedcardNumber:any;
  cardReferenceNumber:any;
  cardNumber:any;
  CardDetails:any;
  constructor(private router: Router,private location: Location,private ngZone: NgZone) {    
    this.CardDetails=location.getState();
    this.cardNumber=this.CardDetails.cardData.CardNumber;
    this.cardNo=(this.cardNumber).substr(-4);
    this.cardReferenceNumber=this.CardDetails.cardData.CardRefNO }

  ngOnInit(): void {

    this.showCard = true;
   $('.main-header').hide();
   $('.footer-dock-menu').hide();
   //class="main-header ng-star-inserted"
   //class="footer-dock-menu"
   this.txnstatus=this.CardDetails.cardData.txnstatus;
   this.cardNo=(this.cardNumber).substr(-4);
   
  //  this.regDateTime="21 Feb 2023, 5:30 PM";
   this.regDateTime=this.getDate();
  }

  onClose(){
    $('.main-header').show();
    $('.footer-dock-menu').show();
    this.ngZone.run(() => {
    this.router.navigate(['/home','cards']);
  });
  }
  getDate(){
    var date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var min;
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    min = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + min + ' ' + ampm;
    var month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var day=date.getDate();
    var month=month_names[(date.getMonth()+1) - 1];
    var year=date.getFullYear();
    var finalDate=day+" "+month+" "+year+", "+strTime;
    return finalDate;
  }
  
}
